import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';

import { ENPOINT } from '../endpoint';
import { Options } from 'selenium-webdriver/safari';

import { GLOBAL } from '../global';
import { CommentStmt } from '@angular/compiler';

@Injectable()
export class CheckInvoicesService {

  constructor(
    private http: HttpClient,
    
  ) { }
  public url = GLOBAL.url;
  private basePath = ENPOINT.url;

obtenerMasterFacturasPen(sociedad, proveedor, nea, oc, fechai, fechaf, usuario): Observable<any> {

    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('sociedad', sociedad)
      .set('provedor', proveedor)
      .set('nea', nea)
      .set('oc', oc)
      .set('fechai', fechaf)
      .set('fechaf', fechaf)
      .set('estatus', 'Pendiente')
      .set('usuario', usuario)
    };

    return this.http.get(this.basePath + 'master-factura/obtener-facturas', options);
}

buscarFacturas(sociedad, proveedor, ordenCompra, fechaI, fechaF, nea, tipoFactura, referencia, usuario): Observable<any> {

    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('sociedad', sociedad)
      .set('provedor', proveedor)
      .set('fechai', fechaI)
      .set('fechaf', fechaF)
      .set('nea', nea)
      .set('nodocumento', '')
      .set('estatus', 'Pendiente')
      .set('grupoimputacion', '')
      .set('tipo', tipoFactura)
      .set('referencia', referencia)
      .set('oc', ordenCompra)
      .set('usuario', usuario)
    };
 
    return this.http.get(this.basePath + 'master-factura/obtener-facturas', options);
}

almacenarPosiciones(uuid, sociedad, indicadorIva, conceptos, fecha): Observable<any> {
  const body = '';
  const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
  const options = {
    headers: httpHeaders,
    withCredentials: true,
    params: new HttpParams()
    .set('uuid', uuid)
    .set('sociedad', sociedad)
    .set('indicadorIva', indicadorIva)
    .set('conceptos', conceptos)
    .set('fechaCont', fecha)
  };
  return this.http.post(this.basePath +
    'factsoc-fb60/revision', body, options);
}


postContabilizar(usuario, data): Observable<any> {
    const body = JSON.stringify(data);
    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    const options = {
      headers: httpHeaders,
      withCredentials: true
        };
    return this.http.post(this.basePath + 'master-factura/procesar-facturas?usuario=' + usuario, body, options);
} 

eliminarFactura(uuid): Observable<any> {
  const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
  const options = {
    headers: httpHeaders,
    withCredentials: true,
    params: new HttpParams()
    .set('uuid', uuid)
      };
  return this.http.delete(this.basePath + 'master-factura/eliminar-factura', options);
}

downloadXml(base64Route: string) {
  const params = new HttpParams()
    .set('ruta', base64Route);

  return this.http.get(`${this.basePath}master-factura/obtener-xml`, { 
    responseType: 'blob',
    params
  });
}

downloadPdf(base64Route: string) {
  const params = new HttpParams()
    .set('ruta', base64Route);

  return this.http.get(`${this.basePath}master-factura/obtener-pdf`, { 
    responseType: 'blob',
    params
  });
}

}



// WEBPACK FOOTER //
// ./src/app/services/check-invoices/check-invoices.service.ts